<div class="body">
    <img class="preview-image" *ngIf="productPictureData" src="{{productPictureData}}" />
    <div class="content">
        <div class="headline">
            {{productName}}
        </div>
        <div class="sub-title">
            Produktnummer {{productNumber}}
        </div>
        <div *ngIf="count" class="counter">
            {{count}} mal im Warenkorb
        </div>
        <button mat-raised-button class="footer-button" color="accent">
            Details
        </button>
        <button class="footer-button" mat-raised-button color="primary" (click)="addProduct()">
            Warenkorb hinzufügen
        </button>
    </div>
</div>